import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-distribution',
  templateUrl: './distribution.component.html',
  styleUrls: ['./distribution.component.scss'],
})
export class DistributionComponent {
  @Input() data: any[] = [];

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }
}
